var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.d{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-width:1.5px;}.d{stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2861 -3943)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2861 3943)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.724 0.081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2833.813 -3941.063)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2858.659-3932.883s-1.548-8.18,5.158-8.18,12.307,9.433,9.359,18.2-15.623,10.317-14.518-.516",
    transform: "translate(2863.307 3941.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2838.856-3933.751s.624,2.948-6.632,4.592c-7.645,2.2-4.937,10.713-5.411,18.874",
    transform: "translate(2850.205 3941.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2846.049-3926.708s-1.489-2.081-7.76-3.153",
    transform: "translate(2861.016 3941.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2847.659-3924.643s-.456-4.089-5.418-7.661",
    transform: "translate(2858.895 3944.063)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2859.605 -3941.063)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2843.49-3932.883s1.548-8.18-5.158-8.18-12.307,9.433-9.359,18.2,15.623,10.317,14.518-.516",
    transform: "translate(2858.813 3941.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2850.983-3933.751s-.624,2.948,6.632,4.592c7.645,2.2,4.939,10.848,5.414,19.009",
    transform: "translate(2859.605 3941.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2853.809-3926.708s1.489-2.081,7.76-3.153",
    transform: "translate(2858.813 3941.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2853.078-3924.643s.456-4.089,5.418-7.661",
    transform: "translate(2861.813 3944.063)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-2838.842-3895.1v-3.794s-4.54-.78-5.455-3.134.949-8.377,8.013-8.334,8.8,5.1,7.679,8.334-5.891,3.134-5.891,3.134v3.794"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality1);
export default __webpack_public_path__ + "static/media/speciality1.b51944c656d3552da62b4c22e70cf378.svg";
export { ForwardRef as ReactComponent };